import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This is to track the device categories from the backend.
 */
const INBOUND_FILTER_LIST_KEY = 'inbound-filter-list-query';

/**
 * This hook fetches list of inbound filter items from mock APi.
 */
export const useFetchInboundFilterQuery = () => {
  const { data, isError, isFetching, error, isPending, refetch } =
    useQueryWithUserId({
      queryKey: [INBOUND_FILTER_LIST_KEY],
      networkMode: 'always',
      queryFn: INBOUND_API.fetchInboundFilterListOptions,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    refetchFilterListOptions: refetch,
  };
};
